module.exports = __webpack_public_path__ + "static/media/ios-arrow-dropleft-circle.440c0e1b.svg";